import React from "react";
import PropTypes from "prop-types";
import StackedPromotionRow from "./StackedPromotionRow";
import DerivedRatePopover, {
  getDerivedRateDiscountDisplay,
} from "./DerivedRatePopover";
import { getOwnPriceConfig } from "./utils";

// A bounded section of the stacked promotions list: one top-level derived
// rate followed by its nested descendants (as produced by
// buildStackedPromotionGroups).
const StackedDerivedRateGroup = ({
  parent,
  descendants,
  dayOfWeek,
  currency,
}) => (
  <div className="stacked-promotions__group">
    <StackedPromotionRow
      name={parent.name}
      discountValue={getDerivedRateDiscountDisplay(
        getOwnPriceConfig(parent),
        dayOfWeek,
        currency
      )}
      popover={
        <DerivedRatePopover
          derivedRate={parent}
          dayOfWeek={dayOfWeek}
          currency={currency}
        />
      }
    />
    {descendants.map(({ rate, depth, isLastSibling, ancestorRailDepths }) => (
      <StackedPromotionRow
        key={`dr-${rate.id}`}
        depth={depth}
        isLastSibling={isLastSibling}
        ancestorRailDepths={ancestorRailDepths}
        name={rate.name}
        discountValue={getDerivedRateDiscountDisplay(
          getOwnPriceConfig(rate),
          dayOfWeek,
          currency
        )}
        popover={
          <DerivedRatePopover
            derivedRate={rate}
            dayOfWeek={dayOfWeek}
            currency={currency}
          />
        }
      />
    ))}
  </div>
);

StackedDerivedRateGroup.propTypes = {
  parent: PropTypes.object.isRequired,
  descendants: PropTypes.arrayOf(
    PropTypes.shape({
      rate: PropTypes.object,
      depth: PropTypes.number,
      isLastSibling: PropTypes.bool,
      ancestorRailDepths: PropTypes.arrayOf(PropTypes.number),
    })
  ),
  dayOfWeek: PropTypes.number,
  currency: PropTypes.string,
};

export default StackedDerivedRateGroup;
